export const inspectTable_1 = [
  {
    content: "지반의 붕괴 위험을 방지하기 위하여 지반을 안전한 경사로 하고 빗물이나 지하수 등을 배제하고 적절히 지보공을 설치하는 등 필요한 조치를 한다.",
    isChecked: "",
    title: "지반 안전성 확보",
  },
  {
    content: "급작스런 지하수위 상승 등 지반의 변화가 있을 경우 전문가 검토를 통해 안전을 확보한다.",
    isChecked: "",
    title: "지반 안전성 확보",
  },
  {
    content:
      "동절기, 해빙기, 장마철 등 취약시기에 대비하여 안전계획을 수립한다.<br/>*동절기 : 지반의 동결·팽창에 따른 비탈면, 흙막이 구조물 붕괴 <br/>해빙기 : 동결된 지반이 융해되어 침하되면서 구조물을 약화시켜 붕괴<br/>장마철 : 지속적인 강우로 토압이 증가하여 흙막이 등 지반 붕괴",
    isChecked: "",
    title: "취약시기 대비",
  },
];
export const inspectTable_2 = [
  {
    content: "굴착장소 및 그 주변의 지반 및 지하매설물에 대하여 사전에 조사하여야 한다.",
    isChecked: "",
    title: "사전 조사 적정성",
  },
  {
    content: "장비의 진입로와 작업장에서의 주행로를 확보하고, 다짐도, 노폭, 경사도 등의 상태를 점검하여야 한다.",
    isChecked: "",
    title: "사전 조사 적정성",
  },
  {
    content: "굴착사면 설계시 활동면의 전단강도와 전단응력에 대한 기준안전율을 확보하여야 한다. ",
    isChecked: "",
    title: "사전 설계 적정성",
  },
  {
    content: "기준 안전율 확보 불가시 앵커, 네일 등 사면 보강을 실시하고, 불가시 흙막이 벽체공법 등으로 굴착공법을 변경하여야 한다.",
    isChecked: "",
    title: "사전 설계 적정성",
  },
  {
    content: "기존 구조물 근접 굴착시 흙막이 벽체 공법 등으로 굴착 공법을 변경하여야 한다.",
    isChecked: "",
    title: "사전 설계 적정성",
  },
  {
    content: "지반의 종류에 따라 굴착면의 기울기를 준수하여야 한다.",
    isChecked: "",
    title: "굴착작업 시 안전대책",
  },
  {
    content: "트랜치 굴착시 굴착사면 기울기 확보가 불가한 경우 간이 흙막이를 설치하여야 한다. ",
    isChecked: "",
    title: "굴착작업 시 안전대책",
  },
  {
    content: "간이 흙막이는 지하 매설물과 간섭이 없는 구조로 하여야 한다.",
    isChecked: "",
    title: "굴착작업 시 안전대책",
  },
  {
    content: "굴착 토사나 차량 등 경사면 및 굴착부 배면에 재하시 최소 이격거리를 확보하여야 한다.",
    isChecked: "",
    title: "굴착완료 후 안전대책",
  },
  {
    content: "용수가 발생한 때에는 신속하게 배수하여야 하며 굴착사면에 우수 등이 유입되지 않도록 차수시설을 하여야 한다.",
    isChecked: "",
    title: "굴착완료 후 안전대책",
  },
];
export const inspectTable_3 = [
  {
    content: "엄지말뚝 설치 위치에 가스관, 상·하수도관 등 장애물의 유무를 유관기관의 설계도서 등으로 조사한 후 인력굴착으로 확인하여야 하며 필요시 이설 등대책을 수립하여야 한다.",
    isChecked: "",
    title: "사전 조사 적정성",
  },
  {
    content: "인접하여 지하 굴착 및 흙막이 공사현장이 있을 경우 당해 흙막이 공사에 미칠 영향을 조사한 후 대책을 수립하여야 한다.",
    isChecked: "",
    title: "사전 조사 적정성",
  },
  {
    content: "시공 전에 엄지말뚝, 토류판, 버팀대, 중간말뚝, 귀잡이, 띠장 등 흙막이의 각 부재가 설계도서에 명시한 규격 및 재질과 부합여부, 단면손상여부, 구부러짐 정도 등을<br/>점검하고 이상 유무를 확인하여야 한다.",
    isChecked: "",
    title: "자재 및 재료의 적정성",
  },
  {
    content: "엄지말뚝의 선단은 설계도서에 의거 충분한 근입깊이를 확보하여야 한다.",
    isChecked: "",
    title: "가설치작업 시 안전대책",
  },
  {
    content: "엄지말뚝은 흙막이 배면부 지반 높이 보다 높게 시공하고 동 위치에 발끝막이판을 설치하는 등 흙막이 상단부의 지표수 유입방지, 낙석, 낙하 발생방지를 위한 필요한 조치를 하여야 한다.",
    isChecked: "",
    title: "설치작업 시 안전대책",
  },
  {
    content: "흙막이 가시설 배면부의 흙막이 높이에 해당하는 범위 내에서는 각종 차량과 토사 및 재료가 적치되지 않도록 계획을 수립하고, 부득이 적재 시는 별도의  하중 검토 등 안전성을 확인하여야 한다.",
    isChecked: "",
    title: "설치완료 후 안전대책",
  },
  {
    content: "엄지말뚝을 설치 후 천공 구멍은 양질의 토사, 모래, 소일 시멘트 등으로 완전히 충진시킨 후에 후속공정을 진행하여야 한다. ",
    isChecked: "",
    title: "설치완료 후 안전대책",
  },
];
export const inspectTable_4 = [
  {
    content: "파이프 서포트 동바리 재료는 변형·부식 또는 심하게 손상된 것을 사용해서는 아니 된다.",
    isChecked: "",
    title: "자재 및 재료의 적정성",
  },
  {
    content: "장선 및 멍에는 거푸집 널과 원활히 결합될 수 있는 재료나 결합방식을 고려하여 선정하여야 한다.",
    isChecked: "",
    title: "자재 및 재료의 적정성",
  },
  {
    content: "파이프 서포트 동바리는 구조를 검토한 후 조립도를 작성하고, 조립도에 따라 조립하여야 한다.",
    isChecked: "",
    title: "사전 설계 적정성",
  },
  {
    content: "조립도에는 동바리·멍에 등 부재의 재질·단면규격·설치간격 및 이음방법 등을 명시하여야 한다.",
    isChecked: "",
    title: "사전 설계 적정성",
  },
  {
    content: "거푸집 동바리는 시공전 조립·콘크리트 타설·해체 계획과 안전시공 절차 등 시공계획을 수립하여야 한다.",
    isChecked: "",
    title: "설치작업 시 안전대책",
  },
  {
    content: "동바리를 지반에 설치하는 경우에는 침하를 방지하기 위하여 콘크리트를 타설하거나, 두께 45 mm 이상의 깔목, 깔판, 전용 받침 철물, 받침판 등을  설치하여야 한다.",
    isChecked: "",
    title: "설치작업 시 안전대책",
  },
  {
    content: "높이 2미터 이내마다 수평연결재를 2개 방향으로 설치하고 수평연결재의 변위를 방지 해야한다.",
    isChecked: "",
    title: "설치작업 시 안전대책",
  },
  {
    content: "콘크리트 타설작업 시 콘크리트 타설순서 등 타설계획을 수립하여야 한다.",
    isChecked: "",
    title: "콘크리트 타설작업 시 안전대책",
  },
  {
    content: "콘크리트 타설작업 시 편심이 발생하지 않도록 분산하여 타설하여야 한다. ",
    isChecked: "",
    title: "콘크리트 타설작업 시 안전대책",
  },
];
